import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="bg-[#0D0C0B] text-[#F5F1E8]">
    {/* Pre-footer CTA strip */}
    <div className="border-y border-[#C4A84F]/15 bg-[#C4A84F]/5">
      <div className="max-w-7xl mx-auto px-6 py-7 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex gap-1">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="fa-solid fa-star text-[#C4A84F] text-sm" />
            ))}
          </div>
          <span className="text-[#F5F1E8]/55 text-sm font-sans">5-Star Rated · 20+ Years · Licensed &amp; Insured</span>
        </div>
        <a href="tel:912-409-2031" className="btn-gold py-3">
          <i className="fa-solid fa-phone text-[11px]" />
          912-409-2031
        </a>
      </div>
    </div>

    {/* Main footer content */}
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

        {/* Brand */}
        <div className="lg:col-span-1">
          <img
            src="https://lirp.cdn-website.com/9a1ab3f9/dms3rep/multi/opt/remove.photos-removed-background+%2811%29-1920w.png"
            alt="Masters Fencing — St. Mary's Georgia"
            className="h-14 w-auto object-contain mb-5"
          />
          <p className="text-[#F5F1E8]/48 text-sm leading-relaxed mb-7 max-w-xs">
            St. Mary's, Georgia's premier fencing contractor — over 20 years of craftsmanship, durability, and trusted local service across Camden County.
          </p>
          <div className="flex gap-3">
            <a
              href="https://www.facebook.com"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className="w-9 h-9 flex items-center justify-center border border-[#C4A84F]/30 text-[#C4A84F] hover:bg-[#C4A84F] hover:text-[#0D0C0B] hover:border-[#C4A84F] transition-all cursor-pointer"
            >
              <i className="fa-brands fa-facebook-f text-sm" />
            </a>
            <a
              href="https://www.google.com/maps/place/Masters+Fencing/@30.863178,-81.6164476,9z"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className="w-9 h-9 flex items-center justify-center border border-[#C4A84F]/30 text-[#C4A84F] hover:bg-[#C4A84F] hover:text-[#0D0C0B] hover:border-[#C4A84F] transition-all cursor-pointer"
            >
              <i className="fa-brands fa-google text-sm" />
            </a>
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-serif text-lg text-[#F5F1E8] mb-2 tracking-wide">Services</h4>
          <div className="w-8 h-[2px] bg-[#C4A84F] mb-6" />
          <ul className="space-y-3.5">
            {[
              'Chain-Link Fencing',
              'Wood Privacy Fence',
              'Steel Fence',
              'Vinyl Fence',
              'Aluminum Fence',
              'Custom Gates',
            ].map((s) => (
              <li key={s}>
                <Link
                  to="/services"
                  className="text-sm text-[#F5F1E8]/48 hover:text-[#C4A84F] transition-colors flex items-center gap-2 hover-underline"
                >
                  <i className="fa-solid fa-chevron-right text-[9px] text-[#C4A84F]" />
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-serif text-lg text-[#F5F1E8] mb-2 tracking-wide">Navigation</h4>
          <div className="w-8 h-[2px] bg-[#C4A84F] mb-6" />
          <ul className="space-y-3.5">
            {[
              { label: 'Home',          path: '/' },
              { label: 'Our Services',  path: '/services' },
              { label: 'About Us',      path: '/about' },
              { label: 'Service Areas', path: '/locations' },
            ].map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-sm text-[#F5F1E8]/48 hover:text-[#C4A84F] transition-colors flex items-center gap-2 hover-underline"
                >
                  <i className="fa-solid fa-chevron-right text-[9px] text-[#C4A84F]" />
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-serif text-lg text-[#F5F1E8] mb-2 tracking-wide">Contact</h4>
          <div className="w-8 h-[2px] bg-[#C4A84F] mb-6" />
          <ul className="space-y-5">
            <li>
              <a
                href="tel:912-409-2031"
                className="flex items-start gap-3 text-sm text-[#F5F1E8]/55 hover:text-[#C4A84F] transition-colors"
              >
                <i className="fa-solid fa-phone text-[#C4A84F] mt-0.5 text-xs" />
                912-409-2031
              </a>
            </li>
            <li>
              <a
                href="https://www.google.com/maps/place/Masters+Fencing/@30.863178,-81.6164476,9z"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-start gap-3 text-sm text-[#F5F1E8]/55 hover:text-[#C4A84F] transition-colors"
              >
                <i className="fa-solid fa-location-dot text-[#C4A84F] mt-0.5 text-xs shrink-0" />
                104 Admiral's Walk Dr<br />St. Marys, GA 31558
              </a>
            </li>
            <li className="flex items-start gap-3 text-sm text-[#F5F1E8]/55">
              <i className="fa-regular fa-clock text-[#C4A84F] mt-0.5 text-xs shrink-0" />
              <div>
                <div>Mon – Sat: 6:00am – 6:00pm</div>
                <div className="text-[#F5F1E8]/30 text-xs mt-0.5">Sunday: Closed</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-white/8">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="text-xs text-[#F5F1E8]/28 font-sans">
          &copy; 2026 Masters Fencing. All rights reserved. · St. Mary's, Georgia
        </span>
        <span className="flex items-center gap-2 text-xs text-[#F5F1E8]/28 font-sans">
          <i className="fa-solid fa-shield-halved text-[#C4A84F] text-[10px]" />
          Licensed &amp; Insured · Georgia Certified Contractor
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
